module.exports = __webpack_public_path__ + "static/media/pastEvents.5a4dfd71.png";